import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getApiUrl } from "../../config/api";

interface ImagePreview {
  file: File;
  preview: string;
}

const Products = () => {
  const navigate = useNavigate(); 
  const [images, setImages] = useState<ImagePreview[]>([]);
  const [show, setShow] = useState<boolean>(false);
  const [keyword, setKeyword] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [success, setsuccess] = useState<string>("");

  const [slide, setslide] = useState<boolean>(false);
  const [products, setproducts] = useState<boolean>(false);


  useEffect(() => {
    document.title = "Kissaria";
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute("content", "Kissaria");

    const localShow = localStorage.getItem("open");
    if (localShow === "true") {
      setShow(true);
    }else {
      navigate("/secret-page/dashboard-admin-200"); 
    }
  }, [navigate]);

  

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    const files = Array.from(e.target.files);
    const filePreviews: ImagePreview[] = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setImages((prev) => [...prev, ...filePreviews]);
  };

  const removeImage = (index: number) => {
    const newImages = [...images];
    URL.revokeObjectURL(newImages[index].preview); // clean memory
    newImages.splice(index, 1);
    setImages(newImages);
  };

  

  const uploadImages = async () => {
    if(images.length==0){
      alert('please select some images')
      return
    }
    
    if(images.length<=19 ){
      const formData = new FormData();
      images.forEach(img => formData.append("images", img.file));
    try {
      const res = await fetch(getApiUrl('UPLOAD'), {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if(data.status==400){
        setError('please try later')
      }else{
        setsuccess('images uploaded with success');
      }
    } catch (err) {
      console.error( err);
    }
    }else{
      alert('it is too much')
    }
    
  };



  return (<>
    <div className="w-full bg-white shadow-md">
  <nav className="max-w-6xl mx-auto px-4 py-3 flex justify-center gap-6">
    <a
      href="/secret-page/dashboard-admin-200/products"
      className="text-gray font-semibold hover:text-pink border-b-2 border-transparent hover:border-pink transition duration-300"
    >
      Upload Product Images
    </a>
    <a
      href="/secret-page/dashboard-admin-200/slide"
      className="text-gray font-semibold hover:text-pink border-b-2 border-transparent hover:border-pink transition duration-300"
    >
      Upload Slide Images
    </a>
    <a
      href="/secret-page/dashboard-admin-200/analytics"
      className="text-gray font-semibold hover:text-pink border-b-2 border-transparent hover:border-pink transition duration-300"
    >
      Analytics
    </a>
  </nav>
</div>

<div className="w-full ">
  <h1 className="max-w-6xl mx-auto px-4 py-9 flex justify-center gap-6 text-2xl">Upload Products Images</h1>
</div>

    <div className="w-full max-w-xl mx-auto">
      
    {error ? (
          <div
            className="w-full text-white p-2 rounded-md text-center my-2"
            style={{ backgroundColor: "red" }}
          >
            {error}
          </div>
        ) : null}
        {success ? (
          <div
            className="w-full text-white p-2 rounded-md text-center my-2"
            style={{ backgroundColor: "green" }}
          >
            {success}
          </div>
        ) : null}
    <label className="flex mt-2 flex-col items-center justify-center w-full h-48 border-2 border-dashed border-gray-300 rounded-xl cursor-pointer hover:border-blue-500 transition">
      <div className="flex flex-col items-center justify-center pt-5 pb-6">
        <svg
          className="w-10 h-10 mb-3 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M7 16V4m0 0L3 8m4-4l4 4m5 8h2a2 2 0 002-2V8a2 2 0 00-2-2h-2m-4 8v4m0 0H8m4 0h4"
          />
        </svg>
        <p className="mb-2 text-sm text-gray-500">
          <span className="font-semibold">Click to upload</span> or drag &amp;
          drop
        </p>
        <p className="text-xs text-gray-400">
          PNG, JPG, JPEG up to 10MB each
        </p>
        <p className="text-xl text-gray-400">
          MAX IS 20 IMAGES
        </p>
      </div>
      <input
        type="file"
        accept="image/*"
        multiple
        onChange={handleImageChange}
        className="hidden"
      />
    </label>

    <button onClick={uploadImages} className="w-full bg-pink hover:text-white hover:bg-black my-2 py-2 rounded-full">Submit</button>
    
    <div className="grid grid-cols-3 gap-4 mt-6">
      {images.map((img, index) => (
        <div key={index} className="relative group">
          <img
            src={img.preview}
            alt="preview"
            className="w-full h-32 object-cover rounded-xl shadow-sm border"
          />
          <button
            onClick={() => removeImage(index)}
            className="absolute top-1 right-1 bg-red-600 text-red text-2xl rounded-full w-6 h-6 flex items-center justify-center  transition"
            title="Remove"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  </div></>
  )
}

export default Products